/**
 * @generated SignedSource<<0953c5a44b7844f04948ecc98c91f39d>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ReaderFragment } from 'relay-runtime';
export type ProductType = "community_event" | "course" | "membership_plan" | "pathway" | "%future added value";
import { FragmentRefs } from "relay-runtime";
export type ExperienceSettingsMembershipsTabFragment$data = {
  readonly id: string;
  readonly name: string;
  readonly type: ProductType;
  readonly " $fragmentSpreads": FragmentRefs<"ProductMembersListPageToolbarFragment">;
  readonly " $fragmentType": "ExperienceSettingsMembershipsTabFragment";
};
export type ExperienceSettingsMembershipsTabFragment$key = {
  readonly " $data"?: ExperienceSettingsMembershipsTabFragment$data;
  readonly " $fragmentSpreads": FragmentRefs<"ExperienceSettingsMembershipsTabFragment">;
};

const node: ReaderFragment = {
  "argumentDefinitions": [],
  "kind": "Fragment",
  "metadata": null,
  "name": "ExperienceSettingsMembershipsTabFragment",
  "selections": [
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "id",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "name",
      "storageKey": null
    },
    {
      "alias": null,
      "args": null,
      "kind": "ScalarField",
      "name": "type",
      "storageKey": null
    },
    {
      "args": null,
      "kind": "FragmentSpread",
      "name": "ProductMembersListPageToolbarFragment"
    }
  ],
  "type": "Product",
  "abstractKey": null
};

(node as any).hash = "02ea2a945b9a41cbad02245232d46105";

export default node;
